import { findAncestor } from 'utils/dom'

const handleFocus = (e) => {
  const target = e.target,
  parent = findAncestor(e.target, 'float-container')

  parent.classList.add('active');
  parent.classList.add('focus');
  
}

const handleBlur = (e) => {
  const target = e.target,
        parent = findAncestor(e.target, 'float-container'),
        dropdownContainer = parent.getElementsByClassName('dropdown-search-container'),
        dropDownValue = parent.getElementsByClassName('dropdown-search__single-value')

  if(dropdownContainer) {
    if(dropDownValue && dropDownValue.innerHtml != ''){
      parent.classList.add('active');
    }
    else{
      parent.classList.remove('active');
    }
      
  }else if (!target.value) {
    parent.classList.remove('active');
  }

  parent.classList.remove('focus');
}

export { handleFocus, handleBlur }